import { createFileRoute, useRouter } from '@tanstack/react-router';
import { RoutePermissionGuard } from '@/components/molecules';
import { MembershipFormPanel } from '@/components/organisms/memberships/MembershipFormPanel';

export const Route = createFileRoute('/_dashboard/dashboard/memberships/new')({
  component: NewMembershipPage,
});

function NewMembershipPage() {
  const router = useRouter();

  function closeToIndex() {
    // @ts-expect-error — search required by TanStack Router v1.168
    void router.navigate({ to: '/dashboard/memberships' });
  }

  return (
    <RoutePermissionGuard
      permissions="memberships:create"
      message="You do not have permission to create memberships."
    >
      <MembershipFormPanel
        onCancel={closeToIndex}
        onCreated={(membership) =>
          // @ts-expect-error — search required by TanStack Router v1.168
          void router.navigate({
            to: '/dashboard/memberships/$id',
            params: { id: membership.id },
            replace: true,
          })
        }
      />
    </RoutePermissionGuard>
  );
}
